import { localeMeta } from "@/lib/seo-head";
import { createFileRoute } from "@tanstack/react-router";
import { Check } from "lucide-react";

import { RequestForm } from "@/components/site/RequestForm";
import { Section } from "@/components/site/Section";
import { alternateLinks } from "@/lib/i18n";
import { useT } from "@/lib/i18n-dict";

const TITLE = "Become a partner | factory.online";
const DESCRIPTION =
  "Apply to the factory.online partnership program: reseller or implementation partner, with API access, training, marketing support and recurring revenue.";

const PERKS = [
  "Reseller or implementation partner formats",
  "Product training and certification for your team",
  "API access and a sandbox environment",
  "Marketing support and co-branded materials",
  "Recurring revenue share on every client",
];

export const Route = createFileRoute("/{-$locale}/registration-partners")({
  staticData: { sitemap: true },
  head: ({ params }) => {
    const __m = localeMeta(params, TITLE, DESCRIPTION);
    return ({
    meta: [
      { title: __m.title },
      { name: "description", content: __m.description },
      { property: "og:title", content: __m.title },
      { property: "og:description", content: __m.description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: alternateLinks("/registration-partners"),
  });
  },
  component: PartnersPage,
});

function PartnersPage() {
  const t = useT();
  return (
    <Section className="hero-glow">
      <div className="grid gap-12 lg:grid-cols-[1fr_1.05fr]">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-primary uppercase">
            {t("Partnership program")}
          </p>
          <h1 className="mt-4 font-display text-4xl font-bold text-balance-tight md:text-5xl">
            {t("Grow your consulting business with factory.online")}
          </h1>
          <p className="mt-5 text-lg text-muted-foreground">
            {t("Tell us about your company and the manufacturers you work with. We'll come back with the partnership format, commercial terms and onboarding steps.")}
          </p>
          <ul className="mt-8 grid gap-3">
            {PERKS.map((perk) => (
<li key={perk} className="flex gap-3 text-base text-muted-foreground md:text-lg">
                <Check className="mt-1 size-5 shrink-0 text-primary" aria-hidden />
                {t(perk)}
              </li>
            ))}
          </ul>
        </div>
        <RequestForm
          kind="partner"
          withMessage
          submitLabel="Apply for partnership"
          successTitle="Application received"
          successText="Our partnership team will get in touch to discuss the details."
        />
      </div>
    </Section>
  );
}
